// 匿名コンサルホットライン コンサルが側のテキスト定数
export const hotlineProfessionalText = {
    /**
     * ボタンの文言
     */
    action: {
        sendOffer: () => '相談オファーを送る',
    },
    /**
     * 料金のお支払いについて
     */
    chargePayment: () => [
        'クライアントやWeb会議での相談内容に関わらず、PROFFITからお支払いする金額は一時間あたり一律7万円（税抜き）です。',
        '貴社より請求書をお送り頂きましたら、請求書送付日の翌月末までにPROFFITを運営する合同会社Co-nnect Inc.よりご指定の銀行口座へお振込みいたします。\n※謝礼の支払いにつきましては、直近２ヶ月間に発生した謝礼につきその翌月末日限りにまとめて行うものとします。',
    ],
    /**
     * 今後のスケジュールの説明文言
     */
    futureSchedule: () => [
        {
            description: 'クライアントとチャットで具体的なアドバイスの内容や相談日程をすり合わせます。',
            title: '相談内容をすり合わせる',
        },
        {
            description: 'クライアントから正式に相談の申し込みを受け、受諾します。',
            title: 'クライアントから相談申し込みを受ける',
        },
        {
            description: 'PROFFITのサイト上でWeb会議に参加し、アドバイスを行います。',
            title: 'オンラインで相談する',
        },
    ],
    /**
     * 相談オファーの説明文言
     */
    offerDescription: () => [
        {
            description: 'チャットでのやり取りを通じて、情報提供やアドバイスできる内容を伝えディスカッションのイメージを膨らませましょう。',
            title: 'アドバイス可能な内容をアピールしましょう。',
        },
        {
            description: '相談の実施日程が決まったら、クライアントから正式な申し込みが送られますので、内容を確認して受諾してください。',
            title: '相談日程を調整しましょう。',
        },
    ],
};
